<form [formGroup]="paramPagamentoForm" (keydown.enter)="$event.preventDefault()" (ngSubmit)="salvarOnClick()">
    <div class="form-group row">
      <div class="col-md-3">
        <label class="col-form-label" style="display: inline;">Tempo de verificação em minutos:</label><span class="red">*</span>
      </div>
      <div class="col-md-9 input-group">
        <input
          type="number"
          required
          id="timeMinutos"
          formControlName="timeMinutos"
          class="form-control"/>       
        <div class="invalid-feedback" 
        [ngClass]="{'is-invalid': fcTimeMinutos.errors}">
          {{msgTimeMinutos}}
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-3">
        <label class="col-form-label">Destinatário do e-mail:</label><span class="red">*</span>
      </div>
      <div class="col-md-9">
        <input
          type="email"
          id="destinatario"
          formControlName="destinatario"
          class="form-control"/>       
        <div class="invalid-feedback" [ngClass]="{'is-invalid': fcDestinatario.errors}">
          {{msgDestinatario}}
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-3">
        <label class="col-form-label">Título do e-mail:</label><span class="red">*</span>
      </div>
      <div class="col-md-9">
        <input
          type="text"
          id="tituloEmail"
          formControlName="tituloEmail"
          class="form-control"/>   
        <div class="invalid-feedback" [ngClass]="{'is-invalid': fcTituloEmail.errors}">
          {{msgTituloEmail}}
        </div>
      </div>
    </div>
  
    <div class="form-group row">
      <div class="col-md-3">
        <label class="col-form-label">Mensagem: </label><span class="red">*</span>
      </div>
      <div class="col-md-9">
        <textarea 
        type="text"
        id="mensagem"
        formControlName="mensagem"
        class="form-control"> </textarea>
        <div class="invalid-feedback" [ngClass]="{'is-invalid': fcMensagem.errors}">
          {{msgMensagem}}
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="controls col-md-9 offset-md-3">
        <button class="btn btn-primary" type="submit">Salvar</button>
        <button (click)="limparOnClick()" class="btn btn" type="button">Limpar</button>
      </div>
    </div>
    <br>
  </form>
  


// WEBPACK FOOTER //
// ./src/app/parametros/param-notificacao/param-notificacao.component.html